// The app's theme: the family's four choices (System, Light, Dark, High
// contrast) on the shared palettes, with the app's accent (_common/styles/
// themes.css). The saved choice keeps the app's old key: "system", "light"
// and "dark" saved under it still hold; an old named theme (tapestry-light,
// forest-dark...) is ignored and the app starts on System.
import {
  createThemeStore,
  familyThemeConfig,
  type ThemeConfig,
} from "@jkast90/kast-common/theme";

export const themeConfig: ThemeConfig = {
  storageKey: "theme",
  ...familyThemeConfig({ light: "#f5f7fa", dark: "#080c14" }),
};

export const themeStore = createThemeStore(themeConfig);
